// pages/ContabilidadeAdmin.js
"use client";

import { useEffect, useState } from "react";
import axios from "axios";
import "../styles/taxasAdmin.css";
import {
  FaPlus,
  FaMoneyBillWave,
  FaRegCalendarAlt,
  FaBalanceScale,
  FaTrash,
  FaEdit,
  FaSave,
  FaTimes,
} from "react-icons/fa";

const ContabilidadeAdmin = () => {
  const [ganhos, setGanhos] = useState([]);
  const [despesas, setDespesas] = useState([]);
  const [resumo, setResumo] = useState({ totalGanhos: 0, totalDespesas: 0, lucroFinal: 0 });

  const [novoGanho, setNovoGanho] = useState({ descricao: "", valor: "" });
  const [novaDespesa, setNovaDespesa] = useState({ descricao: "", valor: "", tipo: "fixa", dataPagamento: "" });

  const [editando, setEditando] = useState(null); // { tipo: 'ganho' | 'despesa', id: '...' }
  const [dadosEdicao, setDadosEdicao] = useState({});

  const token = localStorage.getItem("token");

  // 📌 Buscar dados
  const carregarDados = async () => {
    try {
      const [ganhosRes, despesasRes, resumoRes] = await Promise.all([
        axios.get("https://api.ticketdovaqueiro.com/api/contabilidade/ganhos", { headers: { Authorization: `Bearer ${token}` } }),
        axios.get("https://api.ticketdovaqueiro.com/api/contabilidade/despesas", { headers: { Authorization: `Bearer ${token}` } }),
        axios.get("https://api.ticketdovaqueiro.com/api/contabilidade/resumo", { headers: { Authorization: `Bearer ${token}` } }),
      ]);
      setGanhos(ganhosRes.data);
      setDespesas(despesasRes.data);
      setResumo(resumoRes.data);
    } catch (err) {
      console.error("Erro ao carregar dados:", err);
    }
  };

  useEffect(() => {
    carregarDados();
  }, []);

  // 📌 Adicionar ganho
  const adicionarGanho = async () => {
    if (!novoGanho.descricao || !novoGanho.valor) return;
    await axios.post("https://api.ticketdovaqueiro.com/api/contabilidade/ganhos", novoGanho, { headers: { Authorization: `Bearer ${token}` } });
    setNovoGanho({ descricao: "", valor: "" });
    carregarDados();
  };

  // 📌 Adicionar despesa
  const adicionarDespesa = async () => {
    if (!novaDespesa.descricao || !novaDespesa.valor || !novaDespesa.dataPagamento) return;
    await axios.post("https://api.ticketdovaqueiro.com/api/contabilidade/despesas", novaDespesa, { headers: { Authorization: `Bearer ${token}` } });
    setNovaDespesa({ descricao: "", valor: "", tipo: "fixa", dataPagamento: "" });
    carregarDados();
  };

  // 📌 Excluir
  const excluirItem = async (tipo, id) => {
    if (!window.confirm("Tem certeza que deseja excluir?")) return;
    await axios.delete(`https://api.ticketdovaqueiro.com/api/api/contabilidade/${tipo}/${id}`, { headers: { Authorization: `Bearer ${token}` } });
    carregarDados();
  };

  // 📌 Iniciar edição
  const iniciarEdicao = (tipo, item) => {
    setEditando({ tipo, id: item._id });
    setDadosEdicao({ ...item });
  };

  // 📌 Cancelar edição
  const cancelarEdicao = () => {
    setEditando(null);
    setDadosEdicao({});
  };

  // 📌 Salvar edição
  const salvarEdicao = async () => {
    if (!editando) return;
    await axios.put(`https://api.ticketdovaqueiro.com/api/contabilidade/${editando.tipo}/${editando.id}`, dadosEdicao, {
      headers: { Authorization: `Bearer ${token}` },
    });
    setEditando(null);
    setDadosEdicao({});
    carregarDados();
  };

  return (
    <div className="taxas-admin-container">
      <h2>
        <FaBalanceScale style={{ marginRight: 10 }} /> Contabilidade do Admin
      </h2>

      {/* GRID DE GANHOS */}
      <div className="taxa-form">
        <h3>
          <FaMoneyBillWave style={{ marginRight: 8 }} /> Ganhos
        </h3>
        <div className="form-group">
          <input
            type="text"
            placeholder="Descrição"
            value={novoGanho.descricao}
            onChange={(e) => setNovoGanho({ ...novoGanho, descricao: e.target.value })}
          />
          <input
            type="number"
            placeholder="Valor"
            value={novoGanho.valor}
            onChange={(e) => setNovoGanho({ ...novoGanho, valor: e.target.value })}
          />
          <button onClick={adicionarGanho}>
            <FaPlus /> Adicionar
          </button>
        </div>
        <table>
          <thead>
            <tr>
              <th>Descrição</th>
              <th>Valor</th>
              <th>Data</th>
              <th>Ações</th>
            </tr>
          </thead>
          <tbody>
            {ganhos.map((g) => (
              <tr key={g._id}>
                <td>
                  {editando?.id === g._id && editando.tipo === "ganho" ? (
                    <input
                      value={dadosEdicao.descricao}
                      onChange={(e) => setDadosEdicao({ ...dadosEdicao, descricao: e.target.value })}
                    />
                  ) : (
                    g.descricao
                  )}
                </td>
                <td>
                  {editando?.id === g._id && editando.tipo === "ganho" ? (
                    <input
                      type="number"
                      value={dadosEdicao.valor}
                      onChange={(e) => setDadosEdicao({ ...dadosEdicao, valor: e.target.value })}
                    />
                  ) : (
                    `R$ ${g.valor.toFixed(2)}`
                  )}
                </td>
                <td>{new Date(g.data).toLocaleDateString("pt-BR")}</td>
                <td>
                  {editando?.id === g._id && editando.tipo === "ganho" ? (
                    <>
                      <button onClick={salvarEdicao}><FaSave /></button>
                      <button onClick={cancelarEdicao}><FaTimes /></button>
                    </>
                  ) : (
                    <>
                      <button onClick={() => iniciarEdicao("ganho", g)}><FaEdit /></button>
                      <button onClick={() => excluirItem("ganho", g._id)}><FaTrash /></button>
                    </>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* GRID DE DESPESAS */}
      <div className="taxa-form" style={{ marginTop: 30 }}>
        <h3>
          <FaRegCalendarAlt style={{ marginRight: 8 }} /> Despesas
        </h3>
        <div className="form-group">
          <input
            type="text"
            placeholder="Descrição"
            value={novaDespesa.descricao}
            onChange={(e) => setNovaDespesa({ ...novaDespesa, descricao: e.target.value })}
          />
          <input
            type="number"
            placeholder="Valor"
            value={novaDespesa.valor}
            onChange={(e) => setNovaDespesa({ ...novaDespesa, valor: e.target.value })}
          />
          <select
            value={novaDespesa.tipo}
            onChange={(e) => setNovaDespesa({ ...novaDespesa, tipo: e.target.value })}
          >
            <option value="fixa">Fixa</option>
            <option value="variavel">Variável</option>
          </select>
          <input
            type="date"
            value={novaDespesa.dataPagamento}
            onChange={(e) => setNovaDespesa({ ...novaDespesa, dataPagamento: e.target.value })}
          />
          <button onClick={adicionarDespesa}>
            <FaPlus /> Adicionar
          </button>
        </div>
        <table>
          <thead>
            <tr>
              <th>Descrição</th>
              <th>Valor</th>
              <th>Tipo</th>
              <th>Data Pagamento</th>
              <th>Ações</th>
            </tr>
          </thead>
          <tbody>
            {despesas.map((d) => (
              <tr key={d._id}>
                <td>
                  {editando?.id === d._id && editando.tipo === "despesa" ? (
                    <input
                      value={dadosEdicao.descricao}
                      onChange={(e) => setDadosEdicao({ ...dadosEdicao, descricao: e.target.value })}
                    />
                  ) : (
                    d.descricao
                  )}
                </td>
                <td>
                  {editando?.id === d._id && editando.tipo === "despesa" ? (
                    <input
                      type="number"
                      value={dadosEdicao.valor}
                      onChange={(e) => setDadosEdicao({ ...dadosEdicao, valor: e.target.value })}
                    />
                  ) : (
                    `R$ ${d.valor.toFixed(2)}`
                  )}
                </td>
                <td>
                  {editando?.id === d._id && editando.tipo === "despesa" ? (
                    <select
                      value={dadosEdicao.tipo}
                      onChange={(e) => setDadosEdicao({ ...dadosEdicao, tipo: e.target.value })}
                    >
                      <option value="fixa">Fixa</option>
                      <option value="variavel">Variável</option>
                    </select>
                  ) : (
                    d.tipo
                  )}
                </td>
                <td>
                  {editando?.id === d._id && editando.tipo === "despesa" ? (
                    <input
                      type="date"
                      value={dadosEdicao.dataPagamento?.slice(0, 10)}
                      onChange={(e) => setDadosEdicao({ ...dadosEdicao, dataPagamento: e.target.value })}
                    />
                  ) : (
                    new Date(d.dataPagamento).toLocaleDateString("pt-BR")
                  )}
                </td>
                <td>
                  {editando?.id === d._id && editando.tipo === "despesa" ? (
                    <>
                      <button onClick={salvarEdicao}><FaSave /></button>
                      <button onClick={cancelarEdicao}><FaTimes /></button>
                    </>
                  ) : (
                    <>
                      <button onClick={() => iniciarEdicao("despesa", d)}><FaEdit /></button>
                      <button onClick={() => excluirItem("despesa", d._id)}><FaTrash /></button>
                    </>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* GRID DE RESUMO */}
      <div className="taxa-form" style={{ marginTop: 30, background: "#f4f4f4" }}>
        <h3>📊 Resumo do Mês</h3>
        <p><b>Total de Ganhos:</b> R$ {resumo.totalGanhos.toFixed(2)}</p>
        <p><b>Total de Despesas:</b> R$ {resumo.totalDespesas.toFixed(2)}</p>
        <p><b>Lucro Final:</b> R$ {resumo.lucroFinal.toFixed(2)}</p>
      </div>
    </div>
  );
};

export default ContabilidadeAdmin;
